import { useContext } from 'react';
import { CandidateProfileContext } from '../context/candidate-profile-context';

export const useCandidateProfileContext = () => {
  const context = useContext(CandidateProfileContext);

  if (!context)
    throw new Error('useCandidateProfileContext context must be use inside CandidateProfileProvider');

  return context;
};
